import React from 'react'
import ReactPaginate from 'react-paginate'
import { PaginationWrapper, PaginationArrow, FooterText } from '../../../../../theme/Global'

const TablePagination = ({
  recordCount,
  recordType,
  currentPage,
  pageCount,
  onChangePagination,
  rowsPerPage
}) => {
  const startRow = currentPage === 1 ? 1 : (currentPage * rowsPerPage) - (rowsPerPage - 1)
  const endRow = currentPage === 1 ? rowsPerPage : (startRow - 1) + rowsPerPage

  return (
    <PaginationWrapper>
      <FooterText data-testid="pagination-footer-text">
        Showing {startRow} to {endRow > recordCount ? recordCount : endRow} of {recordCount}{' '}
        {recordType}
      </FooterText>
      {pageCount > 1
        ? (
          <ReactPaginate
            data-testid="pagination-links"
            containerClassName="pagination"
            initialPage={currentPage - 1}
            forcePage={currentPage - 1}
            disableInitialCallback
            marginPagesDisplayed={2}
            pageCount={pageCount}
            pageRangeDisplayed={5}
            onPageChange={onChangePagination}
            previousLabel={(
              <span data-testid="pagination-prev">
                <PaginationArrow direction="right" /> Prev
              </span>
          )}
            nextLabel={(
              <span data-testid="pagination-next">
                Next{' '} <PaginationArrow direction="left" />
              </span>
          )}
          />
        )
        : null}
    </PaginationWrapper>
  )
}
export default TablePagination
